export { fetchFeeds as fetchFeedsApi } from './homePage'


// WEBPACK FOOTER //
// ./src/features/api/index.js